// Per-(user, connection, database, table) column display preferences.
// Backed by /api/connections/{id}/databases/{db}/tables/{table}/column-prefs.
//
// Pref shape: { columnName, width, position, pinned }
//
// Storage model: complete snapshots. The frontend always sends every column
// the user has touched (with explicit width/position/pinned), even if only
// one changed — keeps the server-side schema simple and merges trivial.
import { api } from './api.js';

const url = (connId, db, table) =>
  `/api/connections/${connId}/databases/${encodeURIComponent(db)}/tables/${encodeURIComponent(table)}/column-prefs`;

export async function loadColumnPrefs(connId, db, table) {
  try {
    const r = await api.get(url(connId, db, table));
    return r.prefs || [];
  } catch {
    return [];
  }
}

export async function saveColumnPrefs(connId, db, table, prefs) {
  try {
    await api.put(url(connId, db, table), { prefs });
  } catch (_) {
    // best-effort; the optimistic local update remains either way
  }
}

export async function resetColumnPrefs(connId, db, table) {
  try {
    await api.delete(url(connId, db, table));
  } catch (_) {}
}
